/**
 * API base URL for client `$fetch` calls.
 *
 * - **Capacitor:** `runtimeConfig.public.apiBaseUrl` (`NUXT_PUBLIC_API_BASE_URL`), or designer
 *   base URL in production when API base is unset.
 * - **Web:** same-origin in dev (`undefined`); production may use designer base URL only.
 *
 * `NUXT_PUBLIC_API_BASE_URL` must not drive web dev same-origin calls — only applies when
 * `NUXT_CAPACITOR_APP` is set (see `useApiBaseUrl` guard below).
 */
export const useApiBaseUrl = (): string | undefined => {
    const { public: pub } = useRuntimeConfig()
    const designerBase = !import.meta.env.DEV ? pub.designerBaseUrl?.trim() : undefined

    if (pub.NUXT_CAPACITOR_APP) {
        const apiBase = pub.apiBaseUrl?.trim()
        return apiBase || designerBase
    }

    return designerBase
}
